// taken from https://stackoverflow.com/questions/5306680/move-an-array-element-from-one-array-position-to-another
export default function ArrayMove(arr, fromIndex, toIndex) {
  var element = arr[fromIndex]
  arr.splice(fromIndex, 1)
  arr.splice(toIndex, 0, element)
}
